export const addedProductsConstant = {
    ADD_PRODUCTS: 'ADD_PRODUCTS',
    REMOVE_PRODUCTS: 'REMOVE_PRODUCTS',
    INITIAL_PRODUCTS: 'INITIAL_PRODUCTS',
    UPDATE_PRODUCT: 'UPDATE_PRODUCT',
    DELETE_PRODUCT: 'DELETE_PRODUCT',
    UPDATE_CARTPRODUCT : 'UPDATE_CARTPRODUCT'
};